import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";






@Injectable({ providedIn : 'root' })
export class TicketService
{


    constructor(
        private http : HttpClient
    ){}



    get_ticket_conversation(ticket_id : number)
    {
        return this.http.get(`${environment.api_url}/tickets/ticketDetails/${ticket_id}`);
    }



}